import Video from "common/assets/videoBlack.svg";
import React from "react";
import {callErrorMessage, startVideo} from "actions/videoAction";
import {connect} from "react-redux";
import CircularIcon from "components/CircularIcon";
import {history} from "common/history";

export const VideoButtonComponent = ({
  videoEnabled = true,
  channel,
  startNewVideo,
  isBlackedOut,
  isVideoRoomActiveForChatChannel = false,
}) => {

  const onButtonClick = async () => {
    if (isBlackedOut) return;

    let room;
    try {
      room = await startNewVideo(channel, isVideoRoomActiveForChatChannel);
    } catch (e) {
      alert(callErrorMessage(e));
      return;
    }
    history.push(`/video/join-meeting/${room.room}`);
  };


  return (
    <>
      {videoEnabled && (
        <CircularIcon
          onClick={onButtonClick}
          style={{
            backgroundColor: isBlackedOut
              ? "rgba(0, 0, 0, 0.4)"
              : "#ffffff",
          }}
        >
          <img src={Video} alt="Start video" />
        </CircularIcon>
      )}
    </>
  );
};

const mapStateToProps = ({auth: {user: {status: {experiences: {video}}}}}) => ({videoEnabled: video});

export const VideoButton = connect(mapStateToProps, {startNewVideo: startVideo})(VideoButtonComponent);
